export const AI_FEATURE_SELECTION_LOAD_REQUESTED = "AI_FEATURE_SELECTION/LOAD_REQUESTED";
export const AI_FEATURE_SELECTION_LOAD_SUCCESS = "AI_FEATURE_SELECTION/LOAD_SUCCESS";
export const AI_FEATURE_SELECTION_LOAD_FAIL = "AI_FEATURE_SELECTION/LOAD_FAIL";

export const AI_FEATURE_SELECTION_SAVE_REQUESTED = "AI_FEATURE_SELECTION/SAVE_REQUESTED";
export const AI_FEATURE_SELECTION_SAVE_SUCCESS = "AI_FEATURE_SELECTION/SAVE_SUCCESS";
export const AI_FEATURE_SELECTION_SAVE_FAIL = "AI_FEATURE_SELECTION/SAVE_FAIL";

export const appMngmtId = "v3.AI.featureSelection";

export default (state = {
  loading: 0,
  data: [],
  errors: []
}, { type, data }) => {
  switch (type) {
  case AI_FEATURE_SELECTION_LOAD_REQUESTED: {
    ++state.loading;
    return state;
  }
  case AI_FEATURE_SELECTION_LOAD_SUCCESS: {
    --state.loading;
    state.data = data;
    return state;
  }
  case AI_FEATURE_SELECTION_LOAD_FAIL: {
    --state.loading;
    // state.errors.push({ error: data, type });
    return state;
  }
  case AI_FEATURE_SELECTION_SAVE_REQUESTED: {
    ++state.loading;
    return state;
  }
  case AI_FEATURE_SELECTION_SAVE_SUCCESS: {
    --state.loading;
    state.data = data;
    return state;
  }
  case AI_FEATURE_SELECTION_SAVE_FAIL: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  default:
    return state;
  }
};

export const loadFeatureSelectionRequested = data => ({ type: AI_FEATURE_SELECTION_LOAD_REQUESTED, data });
export const loadFeatureSelectionSuccess = data => ({ type: AI_FEATURE_SELECTION_LOAD_SUCCESS, data });
export const loadFeatureSelectionFail = data => ({ type: AI_FEATURE_SELECTION_LOAD_FAIL, data });

export const saveFeatureSelectionRequested = (data, resolve, reject) => ({ type: AI_FEATURE_SELECTION_SAVE_REQUESTED, data, resolve, reject });
export const saveFeatureSelectionSuccess = data => ({ type: AI_FEATURE_SELECTION_SAVE_SUCCESS, data });
export const saveFeatureSelectionFail = data => ({ type: AI_FEATURE_SELECTION_SAVE_FAIL, data });
